var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SpGroundInside"},[(_vm.TheSp.dialog_soldier)?_c('PromoteSelectModal'):_vm._e(),_c('OpDisabledBlock'),_c('ToolBelt'),_c('TurnShowOrEdit'),_c('div',{staticClass:"SpTransformBlock"},[_c('SpBoardWithMembership',{ref:"SpBoardWithMembership"})],1),_c('PieceBox'),_c('NavigateBlock'),_c('SfenShowBlock'),_c('CommentBlock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }